import React from 'react'
import './Tag.scss'
import heading_patch from '../assets/heading_patch.png'

const Tag = (props) => {

    let id = props.section_heading.replaceAll(' ', '')

    const customStyle = {
        position : 'relative',
        top: props.top,
        left: props.left
    }
    
  return (
    <div className='tag_main'>
        <div className='tag_cont' data-aos="fade-up">
        <img className='heading_patch' src={heading_patch} alt="" />
        <h2  style={customStyle} id={id} className='tag_head frankie'>{props.section_heading}</h2>
        </div>
    </div>
  )
}

export default Tag